import React from 'react'
import DialogContent from '@mui/material/DialogContent';
import Paper from '@mui/material/Paper';
import Draggable from 'react-draggable';
import BootstrapDialog, { BootstrapDialogTitle } from '../../dialog/BootstrapDialog'
import PartnerListContainer from '../../../../containers/common/form/modal/PartnerListContainer'

function PaperComponent(props) {
  return (
    <Draggable
      handle="#draggable-partner-dialog"
      cancel={'[class*="MuiDialogContent-root"], button, .MuiButton-root'}
    >
      <Paper {...props} />
    </Draggable>
  );
}

const PartnerModal = ({ link, title, open, handleClose, selectedPartner, selectedPartnerTyp, isModal }) => {
  return (
    <BootstrapDialog
      open={open}
      onClose={handleClose}
      PaperComponent={PaperComponent}
      aria-labelledby="draggable-partner-dialog"
      fullWidth={true}
      maxWidth="lg"
    >
      <BootstrapDialogTitle style={{ cursor: 'move' }} id="draggable-partner-dialog" onClose={handleClose}>
        {title}
      </BootstrapDialogTitle>
      <DialogContent dividers>
        <PartnerListContainer 
          link={link} 
          handleClose={handleClose} 
          selectedPartner={selectedPartner} 
          selectedPartnerTyp={selectedPartnerTyp}
          isModal={isModal ?? true}
        />
      </DialogContent>
    </BootstrapDialog>
  )
}

export default PartnerModal;
